import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=4b25ca9d&scoped=true&"
import script from "./CouponItem.vue?vue&type=script&lang=js&"
export * from "./CouponItem.vue?vue&type=script&lang=js&"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=4b25ca9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b25ca9d",
  null
  
)

export default component.exports